module.exports = __webpack_public_path__ + "img/hero_s@2x.70515097.webp";